import { Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@core/services/icons/icons.service';
import * as AuthActions from '@core/store/auth/auth.actions';
import { selectUser } from '@core/store/auth/auth.selectors';

import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';

import packageInfo from '../../../../../package.json';
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';
import { SidebarItemWithLabelKey } from './sidebar.model';

export type { SidebarItemWithLabelKey } from './sidebar.model';

@Component({
  selector: 'app-sidebar',
  imports: [TranslatePipe, SidebarItemComponent, TooltipComponent],
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {
  topItems = input.required<SidebarItemWithLabelKey[]>();
  bottomItems = input<SidebarItemWithLabelKey[]>([]);
  collapsed = input<boolean>(false);

  headerClick = output();

  private readonly store = inject(Store);

  protected readonly user = toSignal(this.store.select(selectUser));
  protected readonly initials = computed(() =>
    (this.user()?.fullName ?? '')
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0].toUpperCase())
      .join('')
  );

  protected readonly profileRoute = '/profile';
  protected readonly listIcon = ICONS.list;
  protected readonly signOutIcon = ICONS.signOut;
  protected readonly version = packageInfo.version;
  protected readonly isProduction = environment.production;
  protected readonly year = new Date().getFullYear();

  protected logout(): void {
    this.store.dispatch(AuthActions.logout());
  }

  protected trackSidebarItemByRoute(index: number, item: SidebarItemWithLabelKey): string {
    return `${item.item.route}_${item.labelKey}_${index}`;
  }
}
